module.exports = __webpack_public_path__ + "static/media/Certik-icon_old.1a3198fd.svg";